import React from "react";
import { Container } from "react-bootstrap";
import b2b from "../../../../Asset/hero-b2b.svg";

const Third = () => {
  return (
    <>
      <section
        className="side-image-box-section pt-5"
        style={{ backgroundColor: "var(--light-primary-bg)" }}
      >
        <Container>
          <div className="row align-items-center">
            <div className="col-xl-6 col-lg-12 order-2 order-md-1">
              <div className="info-content">
                <div className="title-paragraph">
                  Top executives or business owners make up B2B purchasers.
                </div>
                <p>
                  They are more sophisticated and acquire a thorough awareness
                  of the service that the marketers are providing from an
                  organisational standpoint. They are interested in a specific
                  deal since it will help them expand their business. Therefore,
                  when communicating through digital media, marketers must
                  explain how managers or business owners may increase earnings,
                  save money, and maintain competitiveness over the long term by
                  adopting their product. In this situation, the content must be
                  well-researched, and the marketers must convince the audience
                  to use the advertised goods or service before it’s too late.
                </p>
                <p>
                  B2B web apps are used by firms that sell products or services
                  to other firms. These web apps simplify business processes,
                  optimize business operations, or address a specific
                  operational need within an organization. B2B transactions help
                  businesses maintain a loyal customer base and enhance the
                  whole service experience.
                </p>
              </div>
            </div>
            <div className="col-xl-6 col-lg-12 order-1 order-md-2">
              <div className="info-img">
                <img alt="infoImage" src={b2b} className="w-100" />
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Third;
